import axios from "./axios";

const action = {
    async CreateToken(params) {
        return await axios().post("/connect/token",params
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
}

export default action
